import { Interactions } from "../core/providers/interactions.provider.tsx";
import { I } from "../shared/icons/icons.tsx";
import { HistoryModule } from "../patient/patient-module.page.tsx";

export function PatientHistoryWidget() {
  const { current } = Interactions.usePatient();

  if (!current) {
    return (
      <div className="flex h-full min-h-24 flex-col items-center justify-center rounded-xl border border-dashed border-sf-border py-8 text-center">
        <I.Clock size={20} className="mb-2 text-sf-text-muted" />
        <p className="text-[12.5px] text-sf-text-muted">
          Sélectionnez un patient
        </p>
      </div>
    );
  }

  return <HistoryModule />;
}
